'use strict';

var d3 = require('d3');
var angular = require('angular');
var D3Helper = function D3Helper() {
  var selectChildren = function selectChildren(gClass) {
    return function () {
      return Array.prototype.slice.call(this.childNodes).filter(function (elem) {
        return elem.getAttribute('class').indexOf(gClass) !== -1;
      });
    };
  };
  var findChildrenByClass = function findChildrenByClass(container, gClass) {
    return container.selectAll(selectChildren(gClass));
  };
  var createGroupElement = function createGroupElement(container, gClass, prepend) {
    var gElem = findChildrenByClass(container, gClass);
    if (gElem.empty()) {
      if (prepend) {
        gElem = container.insert('g', ':first-child').attr('class', gClass);
      } else {
        gElem = container.append('g').attr('class', gClass);
      }
    } else {
      gElem = container.select('g.' + gClass);
    }
    return gElem;
  };

  /**
   * Rounds x, y, width and height (or custom list of attributes)
   * of an object.
   *
   * @param {Object} element A configuration object for SVG element
   * @param {Array} [attributes] List of custom attributes
   * @returns {Object}
   */
  var roundCoordinates = function roundCoordinates(element, attributes) {
    attributes = attributes || ['x', 'y', 'width', 'height'];
    attributes.forEach(function (attribute) {
      if (element.hasOwnProperty(attribute)) {
        var item = element[attribute];
        if (typeof item === 'function') {
          element[attribute] = function () {
            var args = Array.prototype.slice.call(arguments);
            var result = item.apply(item, args);
            return typeof result !== 'undefined' ? Math.round(result) : result;
          };
        } else {
          element[attribute] = typeof item !== 'undefined' ? Math.round(item) : item;
        }
      }
    });
    return element;
  };
  var passEvent = function passEvent(eventType, originalEvent, eventTarget) {
    var event = new CustomEvent(eventType);
    event.pageX = originalEvent.pageX;
    event.pageY = originalEvent.pageY;
    event.clientX = originalEvent.clientX;
    event.clientY = originalEvent.clientY;
    eventTarget.dispatchEvent(event);
  };
  var roundExtent = function roundExtent(brushExtent, d3Event) {
    switch (d3Event.mode) {
      case 'move':
        var d0 = Math.round(brushExtent[0]);
        var d1 = d0 + Math.round(brushExtent[1] - brushExtent[0]);
        return [d0, d1];
      case 'resize':
        brushExtent[0] = Math.floor(roundWithDelta(brushExtent[0]));
        brushExtent[1] = Math.ceil(roundWithDelta(brushExtent[1]));

        // if empty when rounded, use floor & ceil instead
        if (brushExtent[0] >= brushExtent[1]) {
          brushExtent[0] = Math.max(brushExtent[0] - 1, 0);
          brushExtent[1] = Math.max(brushExtent[1], 1);
        }
        return brushExtent;
    }
  };
  function roundWithDelta(val) {
    var rounded = Math.round(val);
    return Math.abs(val - rounded) < 0.01 ? rounded : val;
  }
  function getMouseCurrentXY(svgElement, d3MouseFn) {
    var svgMousePoint = svgElement.createSVGPoint();
    var currentMouseXYWithinSVG = d3MouseFn(svgElement);
    svgMousePoint.x = currentMouseXYWithinSVG[0];
    svgMousePoint.y = currentMouseXYWithinSVG[1];
    return svgMousePoint;
  }
  function createDraggableBars(brushHeight, d) {
    var e = +(d === 'e');
    var x = e ? 1 : -1;
    var y1, y2;
    if (brushHeight > 100) {
      y1 = brushHeight / 3;
      y2 = 2 * y1;
    } else {
      y1 = 0;
      y2 = brushHeight;
    }
    return 'M' + 0.5 * x + ',' + y1 + 'A6,6 0 0 ' + e + ' ' + 6.5 * x + ',' + (y1 + 6) + 'V' + (y2 - 6) + 'A6,6 0 0 ' + e + ' ' + 0.5 * x + ',' + y2 + 'Z' + 'M' + 2.5 * x + ',' + (y1 + 8) + 'V' + (y2 - 8) + 'M' + 4.5 * x + ',' + (y1 + 8) + 'V' + (y2 - 8);
  }
  function breakLabelIntoSeparateLines(text) {
    text.each(function () {
      var text = d3.select(this);
      var lines = text.text().split('|');
      if (lines.length > 1) {
        var lineHeight = 1.2;
        var y = text.attr('y');
        var dy = parseFloat(text.attr('dy'));
        var tspan = text.text(null);
        lines.forEach(function (line, i) {
          tspan = text.append('tspan').text(line).attr({
            'x': 0,
            'y': y,
            'dy': (i === 0 ? dy : lineHeight * i + dy) + 'em'
          });
        });
      }
    });
  }
  function adjustTooltipTopPosition() {
    var tooltip = angular.element('body').find('.d3-tip.d3-chart-tooltip');
    var tooltipTopPos = tooltip.offset().top;
    if (tooltipTopPos < 0) {
      tooltip.css('top', 0);
    }
  }
  return {
    createGroupElement: createGroupElement,
    roundCoordinates: roundCoordinates,
    passEvent: passEvent,
    roundExtent: roundExtent,
    getMouseCurrentXY: getMouseCurrentXY,
    createDraggableBars: createDraggableBars,
    breakLabelIntoSeparateLines: breakLabelIntoSeparateLines,
    adjustTooltipTopPosition: adjustTooltipTopPosition,
    findChildrenByClass: findChildrenByClass
  };
};
D3Helper.$inject = [];
module.exports = D3Helper;